<template>
  <div class="container mt-5">
    <div v-if="sortedScores.length > 0">
      <div v-for="(team, index) in sortedScores" :key="team.teamId" :class="['card', index % 2 === 0 ? 'card-even' : 'card-odd']">
        <div class="card-body d-flex align-items-center justify-content-between">
          <div class="rank-circle">{{ getRank(index) }}</div>
          <div class="team-name">{{ team.teamName }}</div>
          <div class="team-score">{{ team.totalScore }}</div>
        </div>
      </div>
    </div>
    <div v-else>
      <p>No Scores Available Yet</p>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { db } from '@/firebase';
import { collection, query, where, onSnapshot, getDocs } from 'firebase/firestore';
import moment from 'moment-timezone';

export default {
  name: 'LeaderboardPage',
  props: {
    selectedLocation: String,
  },
  setup(props) {
    const scores = ref([]);
    const scoreMap = new Map();

    const updateScores = () => {
      scores.value = Array.from(scoreMap.values()).sort(
        (a, b) => b.totalScore - a.totalScore
      );
    };

    const fetchScores = async () => {
      if (!props.selectedLocation) {
        console.error('Selected location is not defined');
        return;
      }

      const todayDate = getTodayDate();

      const gameQuery = query(
        collection(db, 'games'),
        where('location', '==', props.selectedLocation),
        where('date', '==', todayDate)
      );

      const gameSnapshot = await getDocs(gameQuery);


      if (!gameSnapshot.empty) {
        const gameId = gameSnapshot.docs[0].id;

        const teamsQuery = query(
          collection(db, 'teams'),
          where('location', '==', props.selectedLocation),
          where('gameId', '==', gameId)
        );

        onSnapshot(teamsQuery, (teamsSnapshot) => {
          teamsSnapshot.forEach((teamDoc) => {
            const teamData = teamDoc.data();
            const submissionsRef = collection(db, `games/${teamData.gameId}/submissions`);
            onSnapshot(submissionsRef, (submissionsSnapshot) => {
              let totalScore = 0;
              submissionsSnapshot.forEach((submissionDoc) => {
                const submissionData = submissionDoc.data();
                if (submissionData.teamId === teamData.teamId) {
                  totalScore += Number(submissionData.totalScore) || 0;
                }
              });

              scoreMap.set(teamData.teamId, {
                teamId: teamData.teamId,
                teamName: teamData.teamName,
                totalScore,
              });

              updateScores();
            });
          });
        });
      } else {
        console.log('No active game found for:', props.selectedLocation, 'on date:', todayDate);
      }
    };

    onMounted(fetchScores);

    const getRank = (index) => {
      const currentTeam = scores.value[index];
      const firstTiedIndex = scores.value.findIndex(
        team => team.totalScore === currentTeam.totalScore
      );
      return firstTiedIndex + 1;
    };

    return {
      sortedScores: scores,
      getRank,
    };
  },
};

function getTodayDate() {
  const today = moment().tz('America/New_York');
  const formatted = today.format('YYYY-MM-DD');
  return formatted;
}
</script>

<style scoped>
.container {
  max-width: 100%;
  overflow-x: auto;
}

.card {
  width: 30%;
  margin: 0 auto 0.5rem auto;
  border-radius: 15px;
  padding: 0.75rem 2rem;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1)
}

.card-even {
  background-color: #fffcf3;
}

.card-odd {
  background-color: #ffffff;
}

.card-body {
  width: 100%;
  padding: 0;
}

.rank-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border-color: #004d4d;
  background-color: #003380;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  flex-shrink: 0;
  font-weight: bold;
  color: white;
}

.team-name {
  font-size: 1.5rem;
  font-weight: bold;
  text-align: center;
  flex-grow: 1;
  margin: 0 1rem;
}

.team-score {
  font-size: 1.75rem;
  font-weight: bold;
  flex-shrink: 0;
}
</style>
